const FilterSearch = (state = {}, action) => {
  switch (action.type) {
    default: {
      return state;
    }
  }
};

export default FilterSearch;
